import { Translator } from '../configurator/translator';
import { allPackagesCalculatedEvent } from './package-calculator';

export default class PackageSortering {
  constructor(options = {}) {
    ({
      packageIds: this.packageIds = [],
      sorterOptions: this.sorterOptions = [],
      staticStats: this.staticStats = {},
    } = options);

    this.sorterSelect = document.getElementById('package-sorter');
    this.packageContainers = document.querySelectorAll('.products-container');
    this.defaultSortOrder = [...this.packageIds];
    this.packageIdsSorted = [...this.packageIds];
    this.translator = new Translator({ translations: window.application.translations.terrassenplaner });
    this.calculations = [];
    this.init();
  }

  init() {
    if (this.sorterSelect) {
      this.bootstrapDynamicFilters();
      this.attachSortOption('default');
      this.sorterSelect.addEventListener('change', e => this.sortPackages(e.target.value));
    }

    return this;
  }

  bootstrapDynamicFilters() {
    document.addEventListener(allPackagesCalculatedEvent, results => {
      this.calculations = results.detail.calculations;
      this.sorterOptions.forEach(option => this.attachSortOption(option));
    });
  }

  attachSortOption(value) {
    const option = document.createElement('option');
    option.text = this.translator.translate(`package_sort_${value}`);
    option.value = value;
    this.sorterSelect.appendChild(option);
  }

  sortPackageIds(sorter) {
    this.packageIdsSorted = [...this.defaultSortOrder];
    if (sorter !== 'default') {
      this.packageIdsSorted = [...this.defaultSortOrder];
      const compareConfig = this.sorterToPropertyNameMapper(sorter);
      if (compareConfig) {
        this.packageIdsSorted.sort((idA, idB) => {
          const source = compareConfig.source === 'static' ? this.staticStats : this.calculations;
          if (!source[idA]) {
            return 1;
          }
          if (!source[idB]) {
            return -1;
          }
          const valueA = source[idA][compareConfig.propertyName];
          const valueB = source[idB][compareConfig.propertyName];

          return compareConfig.order === 'asc' ? valueA - valueB : valueB - valueA;
        });
      }
    }
  }

  sortDOMElements() {
    if (!this.packageContainers) {
      return;
    }

    // reversing because of .prepend (last node has to go first)
    const prependOrder = [...this.packageIdsSorted].reverse();
    for (const container of this.packageContainers) {
      for (const packageId of prependOrder) {
        const element = container.querySelector(`label[data-package-id="${packageId}"]`);
        if (element) {
          container.prepend(element);
        }
      }
    }
  }

  sortPackages(sorter) {
    this.sortPackageIds(sorter);
    this.sortDOMElements();
  }

  sorterToPropertyNameMapper(sorter) {
    switch (sorter) {
      case 'cheapest':
        return { source: 'dynamic', propertyName: 'price_sum_brutto', order: 'asc' };
      case 'fastest':
        return { source: 'dynamic', propertyName: 'process_time', order: 'asc' };
      case 'supports':
        return { source: 'dynamic', propertyName: 'plan_pad_positions_count', order: 'asc' };
      case 'installation_steps':
        return { source: 'dynamic', propertyName: 'installation_steps', order: 'asc' };
      case 'height':
        return { source: 'static', propertyName: 'structure_height', order: 'asc' };
      default:
        return false;
    }
  }
}
